// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.release-notes-page {
  padding: 20px;
}

.release-notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.release-notes-upload {
  display: flex;
  align-items: center;
  gap: 8px;
}

.release-notes-file-input {
  display: none;
}

.release-notes-upload-btn {
  border: 0;
  border-radius: 4px;
  background: #0B2D71;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  line-height: 1;
}

.release-notes-upload-btn:hover:not(:disabled) {
  cursor: pointer;
  background: #0066B2;
}

.release-notes-upload-btn:disabled {
  opacity: 0.7;
  cursor: default;
}

.release-notes-state {
  padding: 10px 0;
}

.release-notes-error {
  font-weight: 600;
}

.release-notes-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.release-notes-title-btn {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border: 0;
  border-radius: 4px;
  background: #0B2D71;
  color: #fff;
  text-align: left;
  padding: 8px 10px;
  transition: background-color 0.2s ease-in-out, transform 0.15s ease-in-out;
}

.release-notes-list > li {
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px solid var(--surface-300, #d9d9d9);
  border-radius: 6px;
  background: var(--surface-200, #efefef);
}

.release-notes-date {
  font-size: 13px;
  margin-top: 2px;
}

.release-notes-summary {
  font-size: 13px;
  margin-top: 6px;
  line-height: 1.45;
}

.release-summary-section {
  margin: 6px 0 10px;
}

.release-summary-subtitle {
  font-weight: 700;
  margin-bottom: 4px;
}

.release-summary-bullets {
  list-style: disc;
  margin: 0 0 0 18px;
  padding: 0;
}

.release-summary-bullets li {
  margin: 0 0 4px;
  padding: 0;
}

.release-notes-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.28s ease, opacity 0.22s ease;
}

.release-notes-content.expanded {
  max-height: 65vh;
  opacity: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.release-notes-content-inner {
  padding: 10px 2px 2px;
}

.release-notes-title-btn:hover {
  cursor: pointer;
  background: #0066B2;
}

.release-notes-title-btn.expanded {
  background: #0066B2;
}

.release-notes-title-btn.expanded strong {
  font-weight: 800;
}

.release-notes-title-btn strong {
  color: #fff;
}

.release-notes-chevron {
  font-size: 14px;
  color: #fff;
  transition: transform 0.2s ease-in-out;
}

.release-notes-chevron.expanded {
  transform: rotate(90deg);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
